import React from "react";
import styled from "styled-components";
import Popup from "reactjs-popup";

const UpdateButton = styled.div`
  color: white;
  padding: 5px;
  background-color: orange;
  border-radius: 5px;
  text-align: center;
  :hover {
    cursor: pointer;
    opacity: 0.75;
  }
  :not(:last-child) {
    margin-right: 5px;
  }
`;

const Container = ({ text, style, buttonStyle, children }) => {
  return (
    <Popup
      trigger={<UpdateButton style={buttonStyle}>{text}</UpdateButton>}
      modal={true}
      contentStyle={{
        padding: 25,
        width: 300,
        border: 0,
        borderRadius: 10,
        ...style,
      }}
    >
      {children}
    </Popup>
  );
};

export default Container;
